import classNames from "classnames"
import s from '../../index.module.css';
import classes from './index.module.css';
import Button from "@UI/New/Button";
import { useState } from "react";
import { InputWhite } from "@UI/New/InputWhite";
import { useAddAlert } from "@/hooks/useAddAlert";

const ResizeImage = ({closeModal, data}) => {
    const addAlert = useAddAlert();
    const [size, setSize] = useState(data?.node.attrs.width.replace(/\D/g, ''));

    const changeSize = (value) => {
        let newValue = value.replace(/\D/g, '');
        if(newValue && Number(newValue) > 100) {
            newValue = 100
        }
        setSize(newValue)
    }

    const apply = () => {
        if(!size) {
            addAlert({type:'error', title: 'Размер не заполнен'})
            return;
        }
        const pos = data?.getPos()
          data?.editor.view.dispatch(
            data?.editor.view.state.tr.setNodeMarkup(pos, undefined, {
              ...data?.node.attrs,
              width: `${size}%`,
            })
        )
        closeModal()
    }

    return (
        <div className={classNames(s.modalContainer, classes.modalContainer)}>
            <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
                <span className={s.modalHeaderBigTitle}>
                    Введите размер изображения в %
                </span>
            </div>
            </div>
            <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
                <InputWhite className={classes.input} value={size} onChange={changeSize} />
               <Button 
                    onClick={apply}
                    className={classes.button}>
                    Применить
               </Button>
            </div>
        </div>
    )
}
export default ResizeImage;